module.exports = __webpack_public_path__ + "img/pic_bank_CCB@2x.99c8f26b.png";